import i18n from '@/common/i18n'
/**
 * 错误信息常量类
 */
const msgJson = {
  '0': '操作成功',
  '1': '操作失败',
  '500': '系统异常',
  '400': '参数不合法',
  '401': '认证失败',
  '402': '认证过期',
  '403': '访问被拒绝',
  '404': '资源不存在',
  '900': 'ID不能为空',
  '901': '找不到该记录',
  '902': '自定义异常',
  '903': '登录失败，请设置验证码',
  '904': '登录失败，账号密码错误',
  '905': '验证码错误或账号密码错误，请重新输入',
  '906': '验证码已重置，请刷新页面',
  '907': '该账号已被禁用',
  '908': '该微信未绑定用户，不允许登录',
  '909': '微信扫码授权已过期，请重新扫码',
  '910': '手机验证码错误，请重新输入',
  '911': '该手机号码未绑定用户',
  '912': '发送短信验证码失败，请稍候再进行重试',
  '913': '刷新登录状态失败，请重新登录',
  '914': '微信小程序授权失败',
  '915': '短信验证码发送间隔为60秒，请稍候',
  '916': '请输入正确的手机号码',
  '917': '账号密码错误已达5次，请输入验证码',
  '1000': '机构名称不允许为空',
  '1001': '机构名称长度不允许超过20',
  '1002': '不允许超过机构最大层数',
  '1003': '该机构有子机构节点，不允许删除',
  '1004': '该机构下面已经绑定用户，不允许删除',
  '1005': '该机构的上级机构或者同级机构同名，请设置其他名称',
  '1006': '机构名称不允许为空',
  '1007': '已被类别绑定，不允许删除',
  '1008': '所选的适用机构已存在该类别',
  "1009": "类别不存在，删除失败",
  "1010": "类别已被使用，不允许删除",
  '2000': '账号不允许为空',
  '2001': '密码不允许为空',
  '2002': '确认密码不允许为空',
  '2003': '密码和确认密码不一致',
  '2004': '该账号已经存在，请设置其他账号',
  '2005': '该手机号码已经存在，请设置其他号码',
  '2006': '该用户已经绑定设备，不允许删除',
  '2007': '当前登录用户非超级管理员，不允许重置密码',
  '2008': '用户名称长度不允许超过20',
  '2009': '手机号码长度异常',
  '2010': '账号长度不允许超过20',
  '2011': '密码长度不允许超过20',
  '2012': '用户名称不允许为空',
  '2013': '用户角色不允许为空',
  '2014': '该用户为超级管理员，不允许删除',
  '2015': '确认密码长度不允许超过20',
  '2016': '手机号码格式异常，请重新输入',
  '2017': '系统异常，微信授权失败',
  '2018': '系统异常，微信授权失败：state失效',
  '2019': '该用户已经绑定微信，无需重复绑定',
  '2020': '绑定手机失败，手机验证码错误',
  '2021': '该手机号码已经被绑定',
  '2022': '解绑手机失败，手机验证码错误',
  '2023': '解绑手机失败，该用户未绑定手机',
  '2024': '该微信已经绑定其他用户，绑定失败',
  '2025': '旧密码错误，修改个人密码失败',
  '2026': '设备序列号重复，请重新设置',
  '2027': '用户名称重复，请重新设置',
  '2028': '请输入手机号码',
  '2029': '请输入短信验证码',
  '2030': '当前用户没有权限操作',
  '2031': '设备序列号不符合规范，请检查',
  '3000': '角色名称不允许超过20',
  '3001': '该角色已经绑定用户，不允许删除',
  '3002': '该角色名称已经存在，请设置其他名称',
  '3003': '超级管理员角色不允许更新',
  '3004': '该角色为超级管理员，不允许删除',
  '3005': '请至少绑定一个菜单!',
  '3006': '请输入角色名称!',
  '4001': '更新告警状态入参不能为空',
  '4002': '告警已被他人处理',
  '4003': '没有告警信息可处理',
  '4004': '页面和系统长连接类型异常',
  '5001': '所在当前租户没有权限查询',
  '5002': '电子围栏参数异常',
  '5003': '电子围栏名称重复',
  '5004': '电子围栏名称过长',
  '5005': '电子围栏备注过长',
  '5006': '电子围栏多边形点位不能超过20个或者为0',
  '5007': '电子围栏早上打卡时间段错误',
  '5008': '电子围栏晚上打卡时间段错误',
  '5009': '电子围栏生效时间段错误',
  '5010': '电子围栏停留时长太长',
  '5011': '电子围栏停留时长需大于0',
  '5012': '电子围栏早上打卡结束时间太晚',
  '5013': '电子围栏晚上打卡开始时间太早',
  '6001': '用户列表不能为空',
  '6002': '用户列表不能为空',
  '6003': '会话ID不能为空',
  '6004': '广播会话不存在',
  '6005': '会话类型不正确',
  '6006': '入参用户ID不正确',
  '6007': '入参用户ID不正确',
  '6008': '参数有误',
  '6009': '会话ID参数异常',
  '6010': '会话类型入参异常',
  '6011': '广播名称不能为空',
  '6012': '广播名称不允许超过20字符',
  '6013': '设备没有对应的用户',
  '6014': '无权修改群组信息',
  '6015': '语音通话群组名称重复或已被其他人使用',
  '6016': '广播群组名字不能重复',
  '7001': '无权查看设备位置信息',
  '7002': '找不到视频code',
  '7003': '视频类型错误',
  '7004': '参数日期格式异常，请确认',
  '7005': '文字描述字数不能超过30',
  '8001': '此安全帽权限已经分配给机构使用，不能删除',
  '8002': '机构中已经存在该联系人',
  '8003': '频道值不正确',
  '8004': '联系人不存在',
  '9001': '镜像id不能为空',
  '9002': '批次已生效，不可删除！',
  '9003': '升级包存在批次，不能删除！',
  '9004': '镜像id不能为空',
  '9005': '镜像不存在',
  '9006': '需上传文件！',
  '9007': '文件名为空',
  '9008': '文件名超出长度',
  '9009': 'app请上传apk文件，镜像请上传tgz或zip文件！',
  '9010': '文件上传错误',
  '9011': '组织下存在升级批次，不可去除',
  '9012': '已存在此文件名的文件',
  '9013': '镜像文件请上传tgz或zip文件',
  '9014': 'app请上传apk文件',
  '9015': '已存在相同镜像标识且版本号或版本编号重复的镜像',
  '9016': '批次id不能为空',
  '10001': '已存在相同姓名',
  '10002': '视频功能初始化失败',
  '10003': '视频功能获取播放地址失败',
  '10004': '视频功能异常，请联系管理员',
  '10005': '媒体文件删除异常，请联系管理员',
  '10006': '新增wifi热点名字重复',
  '11001': '人脸识别姓名重复',
  '11004': '无权删除此人脸数据',
  '11005': '租户数据不匹配',
  '11006': '图片识别不到人脸',
  '11007': '图片大小超过300k',
  '11008': '图片压缩文件解压失败',
  '11009': '录音文件提取声纹失败，请重新录制语音',
  '11011': '声纹所属人重复，请重新输入',
  '2002010': '仅支持 ‘，’符号',
  "12001": "请创建仓格",
  "12002": "仓格数不等于仓格总数",
  "12003": "仓格没有编号",
  "12004": "仓格编号重复",
  "12005": "仓格编号不能小于1，也不能大于仓格总数",
  "12006": "授权用户数量不能大于单格充电数量",
  "12007": "授权用户没有用户id或者用户名称",
}
/**
 * 错误信息提示
 * @param {Object} state
 * @returns {Object}
 */
export function showErrorMsg(state) {
  if (msgJson[state]) {
    return i18n.t("InterfacePrompt." + state)
  } else {
    return msgJson['1'] + ':' + state
  }
}
